import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationModel } from "@models";
import { GlobalsService, LookupService, SleepService } from "@services";
import Swal from 'sweetalert2';

class LocationsSelectorCheckedModel {
	constructor(location: LocationModel,
		checked: boolean) {
		this.location = location;
		this.checked = checked;
	}

	location: LocationModel;
	checked: boolean;
}

@Component({
	selector: 'locations-selector',
	templateUrl: './locations-selector.component.html',
	styleUrls: ['./locations-selector.component.scss']
})
export class LocationsSelectorComponent implements OnInit {
	@Input("key") key: string;
	@Input() displayMode: 'checkbox' | 'chips' = 'checkbox';
	@Output('onLocationsChanged') onLocationsChangedEmitter: EventEmitter<number[]> = new EventEmitter<number[]>();

	locations: LocationsSelectorCheckedModel[] = [];
	get allLocationsSelected(): boolean {
		return this.locations.length > 0 && this.locations.every(location => location.checked);
	}

	selectAllLocations(): void {
		this.locations.forEach(location => location.checked = true);
		this.onLocationsChanged();
	}

	constructor(private lookupService: LookupService) {
	}

	ngOnInit() {
		this.key = `${this.key}_${GlobalsService.userInfo.userId}`;

		// If this is the first time, just default all checked locations to checked
		let checkedLocations: number[] = GlobalsService.userInfo.allowedLocationIds;

		// See if we've saved the checked locations.  If so, override the defaults
		if (sessionStorage.getItem(this.key)) {
			checkedLocations = JSON.parse(sessionStorage.getItem(this.key) || '[]');
		}

		// Get the locations that this user is allowed to see
		const allowedLocations = GlobalsService.userInfo.allowedLocationIds;

		this.locations = this.lookupService.getLocations()
			.map(location => {
				if (allowedLocations.find(allowedLocationId => location.locationId === allowedLocationId)) {
					const isChecked = (checkedLocations.findIndex(checkedLocation => location.locationId === checkedLocation) >= 0);
					return new LocationsSelectorCheckedModel(location, isChecked);
				}
				else {
					return null;
				}
			})
			.filter(x => x !== null);

		this.onLocationsChanged();
	}

	async onLocationsChanged() {
		await SleepService.sleep();

		const selectedLocationIds = this.locations
			.filter(x => x.checked === true)
			.map(x => x.location.locationId);

		sessionStorage.setItem(this.key, JSON.stringify(selectedLocationIds));

		this.onLocationsChangedEmitter.emit(selectedLocationIds);
	}

}

